"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripBarHandle = exports.stripBarHandleFillClass = exports.stripBarHandleTriggerClass = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const BasicTooltip_1 = require("@jsonjoy.com/ui/lib/4-card/BasicTooltip");
exports.stripBarHandleTriggerClass = 'mutxt-strip-handle';
exports.stripBarHandleFillClass = 'mutxt-strip-handle-fill';
const triggerClass = (0, nano_theme_1.rule)({
    d: 'flex',
    ai: 'center',
    jc: 'flex-start',
    w: '48px',
    h: '14px',
    pad: 0,
    bd: 'none',
    bg: 'transparent',
    cur: 'default',
    opacity: 0,
    pointerEvents: 'none',
    color: 'var(--mutxt-handle-color, currentColor)',
    trs: 'opacity .12s ease, color .12s ease, transform .12s ease',
    '&:active': {
        transform: 'scale(.97)',
    },
    '&:hover': {
        color: 'var(--mutxt-handle-color-hover, var(--mutxt-handle-color, currentColor))',
    },
    [`&:hover .${exports.stripBarHandleFillClass}`]: {
        h: '5px',
    },
});
const fillClass = (0, nano_theme_1.rule)({
    d: 'block',
    w: '40%',
    h: '3px',
    bdrad: '2px',
    bg: 'currentColor',
    trs: 'background-color .12s ease, width .25s ease, height .12s ease',
});
const StripBarHandle = ({ tooltip, ariaLabel, onActivate, visible, color, colorHover, width, }) => {
    const onMouseDown = React.useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
    }, []);
    const onClick = React.useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        onActivate();
    }, [onActivate]);
    const buttonStyle = {};
    if (visible !== undefined) {
        buttonStyle.opacity = visible ? 1 : 0;
        buttonStyle.pointerEvents = visible ? 'auto' : 'none';
    }
    if (color !== undefined)
        buttonStyle['--mutxt-handle-color'] = color;
    if (colorHover !== undefined)
        buttonStyle['--mutxt-handle-color-hover'] = colorHover;
    if (width !== undefined)
        buttonStyle.width = width;
    const fillStyle = visible ? { width: '100%' } : undefined;
    const titleAttr = !tooltip && ariaLabel ? ariaLabel : undefined;
    const button = (React.createElement("button", { type: "button", className: `${triggerClass} ${exports.stripBarHandleTriggerClass}`, title: titleAttr, "aria-label": ariaLabel, onMouseDown: onMouseDown, onClick: onClick, style: Object.keys(buttonStyle).length > 0 ? buttonStyle : undefined },
        React.createElement("span", { className: `${fillClass} ${exports.stripBarHandleFillClass}`, style: fillStyle })));
    return tooltip ? (React.createElement(BasicTooltip_1.BasicTooltip, { renderTooltip: () => tooltip, nowrap: true, delay: 400 }, button)) : (button);
};
exports.StripBarHandle = StripBarHandle;
